import {
  useDeviceStore,
  selectConnectionState,
  selectDeviceInfo,
  selectIsReady,
} from '@/store';

/**
 * Hook to get device connection state with derived booleans
 */
export function useDeviceConnection() {
  const connectionState = useDeviceStore(selectConnectionState);
  const deviceInfo = useDeviceStore(selectDeviceInfo);
  const isReady = useDeviceStore(selectIsReady);

  return {
    connectionState,
    deviceInfo,
    isReady,
    isConnected: connectionState === 'connected' || connectionState === 'busy',
    isConnecting: connectionState === 'connecting',
    isDisconnected: connectionState === 'disconnected',
    hasError: connectionState === 'error',
  };
}

/**
 * Hook to get measurement progress with derived isMeasuring
 */
export function useMeasurementProgress() {
  return useDeviceStore((state) => ({
    ...state.measurementProgress,
    isMeasuring: state.isMeasuring(),
  }));
}

/**
 * Hook to get device battery status
 */
export function useDeviceBattery() {
  return useDeviceStore((state) => ({
    level: state.deviceState.batteryLevel,
    voltage: state.deviceState.batteryVoltage,
    powerState: state.deviceState.powerState,
    isLow: state.hasLowBattery(),
    isCharging: state.deviceState.powerState === 'charging',
  }));
}

/**
 * Hook to get device error with clearError action
 */
export function useDeviceError() {
  const error = useDeviceStore((state) => state.error);
  const clearError = useDeviceStore((state) => state.clearError);

  return { error, clearError };
}
